import { useState } from 'react';
import { api } from '../lib/api.js';

// ─── Equipment Detail View ─────────────────────────────────────────────────────
export function VendorSection({ equipment, allVendors, onLinked, onUnlinked }) {
  const linked = equipment.vendors || [];
  const [showLink, setShowLink] = React.useState(false);
  const [selectedVendorId, setSelectedVendorId] = React.useState('');
  const unlinked = (allVendors || []).filter(v => !linked.find(lv => lv.id === v.id));

  async function handleLink() {
    if (!selectedVendorId) return;
    await api('POST', `/api/equipment/${equipment.id}/vendors`, { vendor_id: parseInt(selectedVendorId) });
    setShowLink(false); setSelectedVendorId('');
    onLinked && onLinked();
  }
  async function handleUnlink(vendorId) {
    await api('DELETE', `/api/equipment/${equipment.id}/vendors/${vendorId}`);
    onUnlinked && onUnlinked();
  }

  return (
    <div className="bg-white rounded-xl border border-gray-200 p-5 mb-4 shadow-sm">
      <div className="flex items-center justify-between mb-3">
        <h3 className="font-semibold text-ink">Vendors</h3>
        {unlinked.length > 0 && (
          <button onClick={() => setShowLink(s => !s)}
            className="px-3 py-1.5 bg-gray-100 text-gray-700 text-xs font-semibold rounded-lg hover:bg-gray-200 transition-all">
            + Link Vendor
          </button>
        )}
      </div>
      {showLink && (
        <div className="flex items-center gap-2 mb-3 p-3 bg-gray-50 rounded-lg">
          <select value={selectedVendorId} onChange={e => setSelectedVendorId(e.target.value)}
            className="flex-1 border border-gray-300 rounded-lg px-2 py-1.5 text-sm text-ink bg-white focus:outline-none">
            <option value="">Select vendor…</option>
            {unlinked.map(v => <option key={v.id} value={v.id}>{v.name}{v.specialty ? ` — ${v.specialty}` : ''}</option>)}
          </select>
          <button onClick={handleLink} disabled={!selectedVendorId}
            className="px-3 py-1.5 bg-crimson text-white text-xs font-semibold rounded-lg hover:bg-crimson/90 transition-all disabled:opacity-40">Link</button>
          <button onClick={() => setShowLink(false)}
            className="px-3 py-1.5 bg-gray-100 text-gray-600 text-xs rounded-lg hover:bg-gray-200 transition-all">Cancel</button>
        </div>
      )}
      {linked.length === 0 ? (
        <p className="text-sm text-gray-400 italic">No vendors linked.{unlinked.length > 0 ? ' Use "+ Link Vendor" to add one.' : ''}</p>
      ) : (
        <div className="space-y-2">
          {linked.map(v => (
            <div key={v.id} className="flex items-start justify-between gap-3 p-3 bg-gray-50 rounded-lg">
              <div className="text-xs space-y-0.5">
                <p className="font-semibold text-ink text-sm">{v.name}</p>
                {v.specialty && <p className="text-gray-500">{v.specialty}</p>}
                {v.phone && <p className="text-gray-600">📞 <a href={`tel:${v.phone}`} className="hover:underline">{v.phone}</a></p>}
                {v.email && <p className="text-gray-600">✉ <a href={`mailto:${v.email}`} className="hover:underline">{v.email}</a></p>}
                {v.address && <p className="text-gray-500">{v.address}</p>}
              </div>
              <button onClick={() => handleUnlink(v.id)}
                className="text-xs text-gray-400 hover:text-red-500 transition-colors flex-shrink-0">Unlink</button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
